import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <p>Resilience is not something you either have or don’t have. It’s
                                                    not fixed and it is important you
                                                    don’t fall into the trap of thinking that once you reach adult
                                                    life, you are what you are and nothing’s
                                                    going to change. Resilience is something that can be learned and
                                                    developed.</p>
                                                <p>In this tool, we’ll help you understand the three attitudes
                                                    needed to build resilience and teach you
                                                    a coping strategy to maintain it.</p>

                                                <div className="circle_title"><img
                                                    src={require('@images/Browndot.png')}/>
                                                    alt=""/>BUILDING RESILIENCE – THREE RESILIENT ATTITUDES
                                                </div>
                                                <p>Over the course of twelve years, psychologists in the US studied
                                                    resilience in the workplace,
                                                    identifying its three foremost characteristics – the 3 Cs.<a
                                                        className="superscripttext "
                                                        href="further_info.php?course=300"><sup>4</sup></a> Significantly,
                                                    each of these can be
                                                    nurtured and developed.</p>
                                                <div className="innovativeimg">
                                                    <img
                                                        src={require('@images/resiliance_img.png')}
                                                        alt=""/>
                                                </div>
                                                <div className="border_subtitle">Commitment</div>
                                                <p>Commitment helps you engage fully in events around you. During
                                                    stressful circumstances, you do
                                                    your best to remain an active participant and don’t fade into
                                                    the background. You find meaning
                                                    and fulfilment through playing an active role in life.</p>
                                                <div className="border_subtitle">Control</div>
                                                <p>Control allows you to take direct, hands-on action to manage
                                                    change and the problems it may
                                                    cause. You firmly believe you can influence the outcome of a
                                                    stressful situation and are, as a
                                                    result, better able to cope with it.</p>
                                                <div className="border_subtitle">Challenge</div>
                                                <p>Challenge helps you embrace change and adversity as normal
                                                    processes. You can identify
                                                    opportunity in every difficulty and think of change as a
                                                    challenge.<a className="superscripttext "
                                                                 href="further_info.php?course=300"><sup>5</sup></a>
                                                </p>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>BUILDING RESILIENCE – A PRACTICAL GUIDE
                                            </div>
                                            <p>Use a paper and pencil to work through the following steps:</p>
                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />
                                            <br/>

                                            <div
                                                className="lightgreencontentbg keyquestionpad  greennumberroundbg1 paraspace"
                                                style={{paddingLeft: '39px !important'}}>
                                                <div className="textBoldLightBG task_padding">Step One</div>
                                                <p>Think about people you work with, in relation to the
                                                    three attitudes of commitment, control and
                                                    challenge.</p><span style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="1"
                                                          value={this.props.pageData?.StepOne?.[1]}
                                                          onChange={this.props.handleChangePageData('StepOne')}/>
                                                </span>
                                                <p>Identify one person you consider to be highly resilient,
                                                    that is, the person who demonstrates strength and
                                                    courage to overcome adversity.</p><span
                                                style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="2"
                                                          value={this.props.pageData?.StepOne?.[2]}
                                                          onChange={this.props.handleChangePageData('StepOne')}/>
                                            </span>
                                                <p>Identify one person who you think lacks resilience, i.e.
                                                    the person who was withdrawn and felt powerless and
                                                    threatened under stress. </p><span
                                                style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="3"
                                                          value={this.props.pageData?.StepOne?.[3]}
                                                          onChange={this.props.handleChangePageData('StepOne')}/>
                                            </span>
                                            </div>
                                            <div className="innovativeimg1">
                                                <img
                                                    src={require('@images/arrow1.1.png')}
                                                    alt="" className="task_align_transform"
                                                    style={{transform: 'translate(10px, -40px)', zIndex:105,position: 'relative'}}/>
                                            </div>
                                            <div className="innovativeimg1">
                                                <img
                                                    src={require('@images/arrow1.1.png')}
                                                    alt="" className="task_align_transform"
                                                    style={{transform: 'translate(10px, -40px)', zIndex:105,position: 'relative'}}/>
                                            </div>
                                            <div className="innovativeimg1">
                                                <img
                                                    src={require('@images/arrow1.1.png')}
                                                    alt="" className="task_align_transform"
                                                    style={{transform: 'translate(10px, -40px)', zIndex:105,position: 'relative'}}/>
                                            </div>

                                            <div className="react-print-display">
                                                <div
                                                    className="lightgreencontentbg keyquestionpad  greennumberroundbg1 paraspace"
                                                    style={{paddingLeft: '39px !important'}}>
                                                    <div className="textBoldLightBG task_padding">Step Two</div>
                                                    <p>Ask yourself the following of each of the people you
                                                        identified:</p>
                                                    <div className="">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>What stressful circumstances did he or she
                                                                encounter?</p></li>
                                                            <textarea className="textareaborder textheght"
                                                                      rows="5"
                                                                      name="1"
                                                                      value={this.props.pageData?.StepTwo?.[1]}
                                                                      onChange={this.props.handleChangePageData('StepTwo')}/>
                                                        </ul>
                                                    </div>
                                                    <div className="">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>What problem-solving actions did the person take?
                                                                Did they work?</p></li>
                                                            <textarea className="textareaborder textheght"
                                                                      rows="5"
                                                                      name="2"
                                                                      value={this.props.pageData?.StepTwo?.[2]}
                                                                      onChange={this.props.handleChangePageData('StepTwo')}/>
                                                        </ul>
                                                    </div>
                                                    <div className="">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>Did the person's coping efforts include getting
                                                                support from others?</p></li>
                                                            <textarea className="textareaborder textheght"
                                                                      rows="5"
                                                                      name="3"
                                                                      value={this.props.pageData?.StepTwo?.[3]}
                                                                      onChange={this.props.handleChangePageData('StepTwo')}/>
                                                        </ul>
                                                    </div>
                                                    <div className="">
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>How did his or her coping efforts express
                                                                attitudes of commitment, control and challenge?</p>
                                                            </li>
                                                            <textarea className="textareaborder textheght"
                                                                      rows="5"
                                                                      name="4"
                                                                      value={this.props.pageData?.StepTwo?.[4]}
                                                                      onChange={this.props.handleChangePageData('StepTwo')}/>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="innovativeimg1">
                                                    <img
                                                        src={require('@images/arrow1.1.png')}
                                                        alt="" className="task_align_transform"
                                                        style={{transform: 'translate(10px, -40px)', zIndex:105,position: 'relative'}}/>
                                                </div>
                                                <div
                                                    className="lightgreencontentbg keyquestionpad  greennumberroundbg1 paraspace"
                                                    style={{paddingLeft: '39px !important'}}>
                                                    <div className="textBoldLightBG task_padding">Step Three</div>
                                                    <p>Reflect on your findings and try to compare them with your
                                                        own reactions to stressful situations. Do you see any
                                                        similarities? Which attitudes do you display well? Which do
                                                        you need to work on?</p><span
                                                    style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="1"
                                                          value={this.props.pageData?.StepThree?.[1]}
                                                          onChange={this.props.handleChangePageData('StepThree')}/>
                                            </span>
                                                    <p>Apply your understanding of those around you to your own
                                                        behaviours - that means borrow the good stuff and actively
                                                        avoid the bad stuff! Practice demonstrating the three
                                                        building blocks of resilience. </p><span
                                                    style={{paddingLeft:'0px'}}>
                                                <textarea className="textareaborder textheght"
                                                          rows="5"
                                                          name="2"
                                                          value={this.props.pageData?.StepThree?.[2]}
                                                          onChange={this.props.handleChangePageData('StepThree')}/>
                                            </span>
                                                </div>
                                            </div>
                                            <div>

                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done task">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.savePageData('Page4')}
                                                        className="button-next-previous-done task">Next &gt;&gt;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}